import PropTypes from 'prop-types';
import React from 'react'

export default class extends React.Component {
    static propTypes = {
		prevSlide: PropTypes.func,
		nextSlide: PropTypes.func,
		title: PropTypes.object.isRequired,
		content: PropTypes.object.isRequired,
	};

    render() {

		return (
			<div>
				<div className="slide-wrapper">
					<header className="bg-mid-main p20">
						<h4 className="text-center mtop0 mbot0">{this.props.title}</h4>
					</header>
					<div className="inner bg-light-main bg-slightly-transparent p20">{this.props.content}</div>
					<footer className="bg-deep-main p20">
						<p className="lead mbot0 text-center text-white">
							{ !!this.props.prevSlide && <span className="pull-left clickable" onClick={this.props.prevSlide}>
								{ this.props.prevSlideIcon ? this.props.prevSlideIcon : <i className="icon icon-chevron-left"></i> }
							</span> }
							{ this.props.continue }
							{ !!this.props.nextSlide && <span className="pull-right clickable" onClick={this.props.nextSlide}>
								{ this.props.nextSlideIcon ? this.props.nextSlideIcon : <i className="icon icon-chevron-right"></i> }
							</span> }
						</p>
					</footer>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationParts/TextSlideTemplate.jsx